import { QueryFactory } from "../../../../Common";
export const QGetPersonalizedLiveEvents = QueryFactory("GetPersonalizedLiveEvents");
//# sourceMappingURL=QGetPersonalizedLiveEvents.js.map